import { useState } from "react";

const useCBMouserOver = () => {
  const [mouseOverData, setMouseOverData] = useState(false);
  const CBMouseHandler = () => setMouseOverData(!mouseOverData);
  return [mouseOverData, CBMouseHandler];
};

export default useCBMouserOver;
